export const shallowFlatten = (values: { [key: string]: unknown }) => {
  let flattenedValues: unknown | undefined;
  Object.keys(values).forEach((keyName) => {
    if (typeof values[keyName] === "object") {
      flattenedValues = { ...(flattenedValues as {}), ...(values[keyName] as {}) };
    } else {
      flattenedValues = { ...(flattenedValues as {}), [keyName]: values[keyName] as {} };
    }
  });
  return flattenedValues;
};

export const recursivelyFlatten = (values: { [key: string]: unknown }) => {
  let flattenedValues: unknown | undefined;
  if (typeof values === "object") {
    Object.keys(values).forEach((keyName) => {
      const newValue = values[keyName];
      if (typeof newValue === "object") {
        flattenedValues = { ...(flattenedValues as {}), ...(recursivelyFlatten(newValue as {}) as {}) };
      } else {
        flattenedValues = { ...(flattenedValues as {}), [keyName]: newValue as {} };
      }
    });
    return flattenedValues;
  }
  return values;
};
/**
 * Recursively flattens an object and includes the object name in the keys.
 * @param variables The object to flatten
 * @param flattenedVariables The object to store the flattened values
 * @param prefieldName The name prefix of the values
 */
export const recursiveFlattenIncludingObjectName = (
  variables: any,
  flattenedVariables: any,
  prefieldName: string
) => {
  if (!variables) {
    return;
  }

  for (const key in variables) {
    const value = variables[key];
    if (typeof value === "object") {
      recursiveFlattenIncludingObjectName(value, flattenedVariables, `${prefieldName}${key}.`);
    } else {
      flattenedVariables[`${prefieldName}${key}`] = value;
    }
  }
};
